import { render } from "./NFTList.vue?vue&type=template&id=aca38d10"
import script from "./NFTList.vue?vue&type=script&lang=js"
export * from "./NFTList.vue?vue&type=script&lang=js"

import "./NFTList.vue?vue&type=style&index=0&id=aca38d10&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__